/**
 * created by tian ruo jun
 SyncModal 同步弹窗
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "antd";


export default class SyncModal extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            data:{
                title: "备注",
                width: 700,
                content: "",
                okText: "确定",
             
                cancelText: "取消",
                onOk: ()=>{},
                onCancel: ()=>{},
            },
            visible:false
        }
    }

    confirm = (data,call) => {
        this.setState({
            visible: true,
            data: data
        },()=>{call&&call()});
    };

    onOk = () => {
        let fun = this.state.data.onOk;
        if (typeof fun === 'function') {
            fun()
        }
    };

    onCancel = () => {
        let fun = this.state.data.onCancel;
        if (typeof fun === 'function') {
            fun()
        }
    };

    destroy = (call) => {
        this.setState({
            visible: false
        },()=>{call&&call()})
    };

    againRender(content){
        this.setState({data:{...this.state.data, content}});
    }

    render() {
        let data = this.state.data;
        return (
            <Modal
                ref={ref=>this.modal=ref}
                visible={this.state.visible}
                title={data.title}
                onOk={this.onOk}
                onCancel={this.onCancel}
                width={data.width}
                okText={data.okText}
                cancelText={data.cancelText}
                footer={data.footer}
                maskClosable={false}

            >
                {data.content}
            </Modal>
        )
    }

}